module.exports = __webpack_public_path__ + "img/gif3.1860aaaa.gif";